/**
 * onlineservices live inventory: POST products/productinventoryclient/GetInventory.
 * Shared by the PDP (common/product-details.js) and the cart (cart/backorder-ship-dates.js).
 *
 * Resolves the service's `result` object
 *   { sku, avaliableQuantity, isDoNotReorder, nextAvailableDate, nextAvailableDateDisplay }
 * or null on ANY failure (bad host/sku, non-2xx, malformed body, network error): callers
 * treat "no data" and "service down" identically, so nothing here throws.
 *
 * `appId` identifies the store so onlineservices can strip a store-specific SKU prefix
 * before the internal lookup (SimpleRetail's "B65848" is "65848" internally). Omit it and
 * the SKU is looked up verbatim, which is correct for every store without a prefix.
 */
export const INVENTORY_PATH = 'products/productinventoryclient/GetInventory';

export async function fetchLiveInventory(host, sku, appId, fetchImpl = (url, init) => window.fetch(url, init)) {
    if (!host || !sku) return null;
    try {
        const response = await fetchImpl(host + INVENTORY_PATH, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(appId ? { sku, appId } : { sku }),
        });
        if (!response.ok) return null;
        const json = await response.json();
        return json && typeof json === 'object' && json.result ? json.result : null;
    } catch (e) {
        return null;
    }
}
